import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  progressBar: (props) => ({
    backgroundColor: theme.colors[props.unfilledColor].background,
    borderRadius: `${props.height / 3}px`,
    width: props.width,
    maxWidth: '100%',

    '& > .progress': {
      backgroundColor: theme.colors[props.filledColor].normal,
      width: '0',
      height: props.height,
      transition: '1s ease',
      transitionDelay: '0.5s',
      borderRadius: 'inherit',
      textAlign: 'center',
      fontSize: 'inherit',
      overflow: 'hidden',
    },
  }),
}));

export default useStyle;
